/* eslint-disable complexity */
/* eslint-disable max-lines */

/* eslint-disable jsx-a11y/label-has-associated-control */
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Box, Button, CircularProgress, Divider, Grid, Typography } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import TextField from '@mui/material/TextField';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import styledComponent from 'styled-components';
import Event from 'src/assets/images/event.png';
import { Disclosures } from 'src/components/FormComponents/Components/Disclosures';
import { Dropdown } from 'src/components/FormComponents/Components/Dropdown';
import LogoLoader from 'src/components/LogoLoader';
import Sidebar from 'src/components/Sidebar/Sidebar';
import { BIND_POLICY, BindPolicyResponse, PaymentMethod } from 'src/configs/APISchemas/BindPolicy';
import { GET_QUOTE } from 'src/configs/APISchemas/GetQuote';
import { ROUTES } from 'src/constants/routes';
import { INVALID_STATES, STATES } from 'src/constants/states';
import { GraphQLRequest } from 'src/helpers/GraphQLRequest';
import { loadPayeezyScript } from 'src/helpers/LoadPayeezyScript';
import { useLocationSearch } from 'src/helpers/hooks/useLocationSearch';
import { updatePurchasePolicyAdditionalData, updatePurchasePolicyInput } from '../../../redux/actions/purchasePolicy';
import { getPurchasePolicyAdditionalData, getPurchasePolicyInput } from '../../../redux/selectors/purchasePolicy';
import { getCompanyVendor } from '../../../redux/selectors/shared';
import { Payeezy } from './Payeezy.service';
import './styles/paymentCard.scss';
import styles from './styles/paymentMsi.module.scss';
import { ContactSupportId } from 'src/constants/constants';
import { logToBackend } from 'src/helpers/BackendLogger';
import { FraudLanguages } from 'src/pages/payment-msi/configs/fraud-language.config';
import { PayeezyConfig } from 'src/pages/payment-msi/configs/payeezy.config';
import { shouldRedirectToCoverages } from 'src/pages/payment-msi/utils/should-redirect-to-coverages.util';

export const StyledDropdown = styledComponent(Dropdown as any)`
  > div:nth-child(2) {
    height: 3.5rem;
  }
  > div:nth-child(3) div[tabIndex="-1"] {
    padding: 1rem 1rem;
  }
`;

const PaymentMsiV1 = () => {
  const getUrlWithQueryParams = useLocationSearch();
  const [loader, setLoader] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [state, setState] = useState('');
  const [address, setAddress] = useState<any>({});
  const [street, setStreet] = useState<any>('');
  const [city, setCity] = useState<any>('');
  const [zip, setZip] = useState<any>('');
  const [options, setOptions] = useState<any>([]);
  const [paymentPlan, setPaymentPlan] = useState<any>('MONTHLY');
  const [agreed, setAgreed] = useState<boolean>(false);
  const [cardData, setCardData] = useState<any>();
  const [email, setEmail] = useState('');

  const history = useNavigate();
  const dispatch = useDispatch();
  const purchasePolicyInput = useSelector(getPurchasePolicyInput);
  const purchasePolicyAdditionalData = useSelector(
    getPurchasePolicyAdditionalData,
  );
  const companyVendor = useSelector(getCompanyVendor);
  const isCompany = !!companyVendor;

  const [addressErrors, setAddressErrors] = useState<string[]>([]);
  const [cardErrors, setCardErrors] = useState<string[]>([]);

  useEffect(() => {
    if (purchasePolicyAdditionalData.purchased) {
      return;
    }

    const redirectToCoverages = shouldRedirectToCoverages(
      purchasePolicyInput,
      purchasePolicyAdditionalData,
    );
    if (redirectToCoverages) {
      history(getUrlWithQueryParams(ROUTES.COVERAGES_DETAIL_PATH), {
        replace: true,
      });
      return;
    }

    const updateQuote = async () => {
      try {
        setShowLoader(true);
        const mutation = GET_QUOTE({
          id: purchasePolicyAdditionalData.id,
          communityId:
            purchasePolicyAdditionalData.communityId?.toString() || '',
          deductible: purchasePolicyInput.deductible?.toString() || '',
          medicalPayments:
            purchasePolicyInput.medicalPayments?.toString() || '',
          personalPropertyCoverage:
            purchasePolicyInput.personalPropertyCoverage?.toString() || '',
          personalLiabilityCoverage:
            purchasePolicyInput.personalLiabilityCoverage?.toString() || '',
          lossOfUse: purchasePolicyInput.lossOfUse?.toString() || '',
          theft: purchasePolicyInput.theft?.toString() || '',
          windHail: purchasePolicyInput.windHail?.toString() || '',
          waterBackup: purchasePolicyInput.waterBackup?.toString() || '',
          petDamage: purchasePolicyInput.petDamage?.toString() || '',
          identityFraud: purchasePolicyInput.identityFraud?.toString() || '',
          fireDepartmentService:
          purchasePolicyInput.optionalCoverages.fireDepartmentService,
          sinkHole: purchasePolicyInput.optionalCoverages.sinkHole,
          ordinanceOrLaw: purchasePolicyInput.optionalCoverages.ordinanceOrLaw,
          rentalIncome: purchasePolicyInput.optionalCoverages.rentalIncome,
          workersCompensation:
          purchasePolicyInput.optionalCoverages.workersCompensation,
          earthquake: purchasePolicyInput.earthquake,
          hurricane: purchasePolicyInput.hurricane,
        });
        const response = await GraphQLRequest(mutation, {
          typeOfQuery: 'GET_QUOTE',
        });
        if (response?.getQuote) {
          if (response?.getQuote.errors) {
            return toast(response?.getQuote?.errors[0]?.message, {
              type: 'error',
            });
          } else {
            dispatch(
              updatePurchasePolicyInput({
                ...response?.getQuote,
              }),
            );
            return response?.getQuote;
          }
        }
        throw Error('Application Not Created');
      } catch (error: any) {
        if (error?.response?.data?.errors) {
          return toast(error.response.data.errors[0].message, {
            type: 'error',
          });
        }
        toast(`We are having some trouble, Please contact support for help. id: ${ContactSupportId.paymentMSIUpdateQuote}`, {
          type: 'error',
        });
        await logToBackend(error.toString());
      }
    };

    window.scrollTo(0, 0);
    updateQuote().then((quote) => {
      setAddress(purchasePolicyInput?.buildingAddress?.value);
      setEmail(purchasePolicyInput.email);
      const paymentPlans = quote.paymentPlans;
      if (paymentPlans) {
        const annualPaymentObj = paymentPlans.find(
          (p: any) => p.paymentPlanCd === 'Annual',
        );
        const monthlyPaymentObj = paymentPlans.find(
          (p: any) => p.paymentPlanCd === 'Monthly',
        );
        const {
          downPaymentAmount: annualDownPayment,
          totalPremiumAmt: annualPremium,
        } = annualPaymentObj;
        const {
          downPaymentAmount: monthlyDownPayment,
          totalPremiumAmt: monthlyPremium,
          installmentFeeAmount: installment,
          installmentPaymentAmount,
        } = monthlyPaymentObj;

        // ([MONTHLY] <MSI_TotalPremiumAmt> + ([MONTHLY] <MSI_InstallmentFeeAmount> * 10)) -[YEARLY] <MSI_TotalPremiumAmt>
        const annualSaving =
          parseFloat(monthlyPremium) +
          parseFloat(installment) * 10 -
          parseFloat(annualPremium);

        setOptions([
          {
            label: 'Monthly',
            cost: '$' + installmentPaymentAmount,
            value: 'MONTHLY',
            subheader: 'Down Payment + 10 installments',
            downPayment: '$' + monthlyDownPayment,
          },
          {
            label: 'Annually',
            cost: '$' + annualPremium,
            value: 'ANNUAL',
            subheader: 'One Time Payment',
            saveText: `$${annualSaving}`,
            downPayment: '$' + annualDownPayment,
          },
        ]);
      }
      setShowLoader(false);
      initialize(quote.companyProductCd, quote.id);
      Payeezy.event.subscribe((data) => {
        handleEvent(data);
      });
    });
  }, []);

  const initialize = (
    companyProductCd: string,
    applicationId: string,
    reinitize = true,
  ) => {
    setTimeout(() => {
      const WIN: any = window;
      WIN.authTokenData = {
        state: purchasePolicyInput?.buildingAddress?.value?.state || purchasePolicyInput.address?.state,
        companyProductCd: companyProductCd,
        applicationId,
      };
      if (WIN.firstdata || !reinitize) {
        WIN.firstdata.createPaymentForm(
          PayeezyConfig,
          Payeezy.hooks,
          Payeezy.onCreate,
        );
      } else {
        loadPayeezyScript();
        initialize(companyProductCd, applicationId);
      }

      WIN.addEventListener('VALIDITY_CHANGE', () => {
        setCardErrors([]);
      });
    }, 500);
  };

  const fillAddress = (value: boolean) => {
    if (value) {
      const state = purchasePolicyInput.buildingAddress.value.state || purchasePolicyInput.address.state;
      const addressNumber = purchasePolicyInput.buildingAddress.value.addressNumber || purchasePolicyInput.address.addressNumber || '';
      const street = purchasePolicyInput.buildingAddress.value.street || purchasePolicyInput.address.street;
      const municipality = purchasePolicyInput.buildingAddress.value.municipality || purchasePolicyInput.address.municipality;
      const postalCode = purchasePolicyInput.buildingAddress.value.postalCode || purchasePolicyInput.address.postalCode;

      setState(state);
      setStreet(
        !isCompany
          ? `${addressNumber} ${street}`
          : street,
      );
      setCity(municipality);
      setZip(postalCode);
      setAddressErrors([]);
    }
  };

  const handleEvent = ({ type, data }: { type: string; data: any }) => {
    switch (type) {
      case 'buttonState': {
        setLoader(data.loading);
        break;
      }
      case 'onSuccess': {
        if (data.data.error) {
          toast(
            data.data.gatewayReason.map((a: any) => a.description).join(','),
            {
              type: 'error',
            },
          );
          break;
        }
        if (
          data.data.card.brand === 'jcb' ||
          data.data.card.brand === 'diners-club'
        ) {
          return toast(data.data.card.brand + ' is not supported', {
            type: 'error',
          });
        }
        const name = data.data.card.name;
        const pattern = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
        if (pattern.test(name)) {
          setCardErrors([...cardErrors, 'cc-name']);
          setLoader(false);
          const element = document.getElementById('error-add-CC-message');
          if (element) {
            window.scroll(element.offsetLeft, element.offsetTop);
          }
          return;
        } else {
          setCardData(data.data);
        }
        setTimeout(() => {
          document.getElementById('buttonAddCCConfirm')?.click();
        }, 100);
        break;
      }
      case 'inCompleteField': {
        setTimeout(() => {
          setCardErrors([...cardErrors, data]);
        }, 100);

        setLoader(false);
        const element = document.getElementById('error-add-CC-message');
        if (element) {
          window.scroll(element.offsetLeft, element.offsetTop);
        }
        break;
      }
      case 'onError': {
        toast(`We are having some trouble, Please contact support for help. id: ${ContactSupportId.paymentMSIHandleEvent}`, {
          type: 'error',
        });
        setLoader(false);
        break;
      }
    }
  };

  const onSubmit = (e: any) => {
    if (!agreed) {
      e.stopPropagation();
      setLoader(false);
      return toast('Please agree to terms and conditions', {
        type: 'error',
      });
    }
    const possibleErrors = [
      { name: 'Street Address', field: street },
      { name: 'City', field: city },
      { name: 'State', field: state },
      { name: 'Zipcode', field: zip },
    ];
    const errors = possibleErrors.filter((field) => !field.field);
    if (zip.length && zip.length !== 5) {
      errors.push({ name: 'Zipcode', field: zip });
    }
    if (errors.length > 0) {
      setAddressErrors(errors.map((error) => error.name));
      e.stopPropagation();
      setLoader(false);
      const element = document.getElementById('billing-address-start');
      if (element) {
        window.scroll(element?.offsetLeft, element?.offsetTop);
      }
      return;
    }
    if (cardData) {
      return completePurchase(cardData);
    }
    setLoader(true);
    document.getElementById('submitCode')?.click();
  };

  const completePurchase = async (data: any) => {
    if (street && city && state && zip && String(zip).length >= 5) {
      setLoader(true);
      try {
        const mutation = BIND_POLICY({
          applicationId: purchasePolicyAdditionalData.id,
          communityId: String(purchasePolicyAdditionalData.communityId),
          billingAddressCity: city,
          billingAddressState: state,
          billingAddressStreet: street,
          billingZipCode: zip,
          paymentPlan: paymentPlan,
          paymentMethod: PaymentMethod.CreditCard,
          paymentToken: data.card.token,
          cardData: {
            creditCardExpirationDate: data.card.exp.month + data.card.exp.year.slice(2),
            creditCardNumber: data.card.last4,
            creditCardName: purchasePolicyInput.firstName,
            creditCardType: data.card.brand === 'american-express' ? 'AMEX' : data.card.brand,
          }
        });
        const response = await GraphQLRequest<BindPolicyResponse>(mutation);
        if (response.bindPolicy) {
          if (response.bindPolicy.errors) {
            return toast(response.bindPolicy.errors[0].message, {
              type: 'error',
              bodyStyle: {
                whiteSpace: 'pre-line',
              },
            });
          } else {
            dispatch(
              updatePurchasePolicyAdditionalData({
                ...response.bindPolicy,
                subscription: paymentPlan,
              }),
            );
            history(getUrlWithQueryParams(ROUTES.CONFIRMATION_PATH));
            return;
          }
        }
        throw Error('Application Not Created');
      } catch (error: any) {
        setLoader(false);
        if (error?.response?.data?.errors) {
          return toast(error.response.data.errors[0].message, {
            type: 'error',
          });
        }
        toast(`We are having some trouble, Please contact support for help. id: ${ContactSupportId.paymentMSICompletePurchase}`, {
          type: 'error',
        });
        await logToBackend(error.toString());
      }
    }
  };
  const getFraudLanguage = () => {
    if (INVALID_STATES[address.state]) {
      return null;
    }
    return FraudLanguages[address.state as keyof typeof FraudLanguages];
  };

  if (showLoader || purchasePolicyAdditionalData.purchased) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="80vh"
      >
        <LogoLoader/>
      </Box>
    );
  }

  function onGoBack() {
    history(getUrlWithQueryParams(ROUTES.COVERAGES_DETAIL_PATH));
  }

  return (
    <Box className="mx-xs-3 mx-md-5 mt-5">
      <Grid
        container
        spacing={1}
        className={`mt-md-5 pt-md-5 ${styles.layout}`}
      >
        <Grid item xs={12} lg={8.5}>
          <Button
            variant="text"
            startIcon={<ArrowBackIosIcon/>}
            onClick={onGoBack}
            sx={{ paddingLeft: '5px' }}
          >
            <Typography variant="button">Back</Typography>
          </Button>
          <Typography variant="h3">We’ve got you covered</Typography>
          <Typography variant="body1">
            Here is your renters insurance quote for{' '}
            {!isCompany
              ? purchasePolicyInput.buildingAddress?.value?.addressNumber
              : null}{' '}
            {address.street},{' '}
            {purchasePolicyInput.buildingUnit &&
              `Unit ${purchasePolicyInput.buildingUnit},`}{' '}
            {address.municipality || address.value.municipality},{' '}
            {address.state || address.value.state}{' '}
            {address.postalCode || address.value.postalCode}. You can pay per
            month or on an annual basis.{' '}
          </Typography>

          <input
            hidden
            id="payment-state"
            value={address.state}
            onChange={() => {
            }}
          />
          <form id="add-cc-form" className="mt-5">
            <RadioGroup
              value={paymentPlan}
              name="paymentPlan"
              onChange={(event) => setPaymentPlan(event.target.value)}
            >
              <Grid container gap={{ xs: 7, md: 2, lg: 4 }}>
                {options.map((option: any) => (
                  <Grid
                    item
                    xs={12}
                    md={5}
                    lg={3}
                    key={option.value}
                    className={`${styles.paymentPlan}
                    ${paymentPlan === option.value ? styles.active : ''}
                    `}
                    marginBottom={10}
                  >
                    <FormControlLabel
                      value={option.value}
                      control={<Radio/>}
                      label={
                        <div className={styles.plan_details_container}>
                          {option.saveText && (
                            <span className={styles.saveText}>
                              <Typography variant="body1" color="white">
                                Save&nbsp;{option.saveText}
                              </Typography>
                            </span>
                          )}
                          <div className={styles.cost_containter}>
                            <Typography variant="h3" className={styles.cost}>
                              {option.cost}
                            </Typography>
                            <Typography variant="h5" className={styles.header}>
                              {option.label}
                            </Typography>
                          </div>
                          <div className={styles.details}>
                            <Typography variant="body1">
                              {option.subheader}
                            </Typography>
                          </div>
                        </div>
                      }
                    />
                    <div className={styles.due_today}>
                      <Typography variant="body1" color="white">
                        Due Today &nbsp;
                      </Typography>
                      <Typography variant="h5" color="white">
                        {option.downPayment}
                      </Typography>
                    </div>
                  </Grid>
                ))}
              </Grid>
            </RadioGroup>
            <Grid container gap={3} marginTop={5} width="100%">
              <Grid item xs={12}>
                <Typography variant="h4">Payment</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1">
                  Upon payment completion, your account statement from your bank
                  or credit
                  <br/> card company will show as &apos;MSI Renters Insurance&apos;.
                </Typography>
              </Grid>
              <Grid item xs={12} paddingRight={{ lg: '180px' }}>
                <Box className={styles.dueToday}>
                  <img
                    src={Event}
                    width={20}
                    height="100%"
                    alt="icon"
                    style={{
                      margin: '10px 20px',
                      width: '36px',
                      height: '36px',
                    }}
                  />
                  <div>
                    <Typography variant="body1" fontWeight="500">
                      Due Today
                    </Typography>
                    <Typography variant="h6">
                      {paymentPlan !== 'MONTHLY'
                        ? options.find((o: any) => o.value === paymentPlan)
                          ?.cost
                        : options.find((o: any) => o.value === paymentPlan)
                          ?.downPayment}
                    </Typography>
                  </div>
                </Box>
              </Grid>
              <Grid item xs={12} paddingRight={{ lg: '180px' }}>
                <label id="error-add-CC-message"></label>
                <Typography variant="h6">Card Details</Typography>
              </Grid>
            </Grid>
            <Grid container spacing={4} marginTop={1}>
              <Grid item xs={12} paddingRight={{ lg: '180px' }}>
                <div
                  className={
                    styles.paymentFields +
                    ' payment-fields empty field_payment_name ' +
                    (cardErrors.includes('cc-name')
                      ? ' invalid-cc-details'
                      : '')
                  }
                  id="cc-name"
                  data-cc-name
                ></div>
                {cardErrors.includes('cc-name') && (
                  <div className={styles['cc-field-invalid']}>Invalid name</div>
                )}
              </Grid>
              <Grid item xs={12} paddingRight={{ lg: '180px' }}>
                <div
                  className={
                    styles.paymentFields +
                    ' payment-fields empty field_payment_card ' +
                    (cardErrors.includes('cc-card')
                      ? ' invalid-cc-details'
                      : '')
                  }
                  id="cc-card"
                  data-cc-card
                ></div>
                {cardErrors.includes('cc-card') && (
                  <div className={styles['cc-field-invalid']}>
                    Invalid card number
                  </div>
                )}
              </Grid>
              <Grid item xs={12} paddingRight={{ lg: '180px' }}>
                <Grid container spacing={4}>
                  <Grid item xs={12} lg={6}>
                    <div
                      className={
                        styles.paymentFields +
                        ' payment-fields empty m-0 field_payment_exp ' +
                        (cardErrors.includes('cc-exp')
                          ? ' invalid-cc-details'
                          : '')
                      }
                      id="cc-exp"
                      data-cc-exp
                    ></div>
                    {cardErrors.includes('cc-exp') && (
                      <div className={styles['cc-field-details-invalid']}>
                        Invalid card expiry date
                      </div>
                    )}
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <div
                      className={
                        styles.paymentFields +
                        ' payment-fields empty m-0 field_payment_cvv ' +
                        (cardErrors.includes('cc-cvv')
                          ? ' invalid-cc-details'
                          : '')
                      }
                      id="cc-cvv"
                      data-cc-cvv
                    ></div>
                    {cardErrors.includes('cc-cvv') && (
                      <div className={styles['cc-field-details-invalid']}>
                        Invalid CVV number
                      </div>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <button hidden id={'submitCode'}></button>
          </form>
          <Grid container spacing={2.5} marginTop={1} marginBottom={10}>
            <span id="billing-address-start"></span>
            <Grid item xs={12} lg={8}>
              <Typography variant="h6">Billing Address</Typography>
            </Grid>
            <Grid
              item
              xs={12}
              paddingRight={{ lg: '180px' }}
              className="checkBoxPaymentAddress"
            >
              <FormControlLabel
                control={
                  <Checkbox
                    name="same_as_address"
                    onChange={(event) => fillAddress(event.target.checked)}
                  />
                }
                label="My billing address is the same as my apartment address."
              />
            </Grid>
            <Grid item xs={12} paddingRight={{ lg: '180px' }}>
              <TextField
                error={addressErrors.includes('Street Address')}
                required
                label="Street"
                name={'street_address'}
                value={street}
                onChange={(e) => {
                  setStreet(e.target.value);
                  setAddressErrors([]);
                }}
                inputProps={{
                  minLength: 1,
                }}
                helperText={
                  addressErrors.includes('Street Address')
                    ? 'Please enter street address'
                    : ''
                }
              />
            </Grid>
            <Grid item xs={12} paddingRight={{ lg: '180px' }}>
              <TextField
                error={addressErrors.includes('City')}
                required
                label="City"
                name={'city'}
                value={city}
                onChange={(e) => {
                  setCity(e.target.value);
                  setAddressErrors([]);
                }}
                inputProps={{
                  minLength: 1,
                }}
                helperText={
                  addressErrors.includes('City') ? 'Please enter city' : ''
                }
              />
            </Grid>
            <Grid item xs={12} paddingRight={{ lg: '180px' }}>
              <Grid container spacing={4}>
                <Grid item xs={12} lg={6}>
                  <StyledDropdown
                    className={`dropdown ${styles.invalid} `}
                    placeholder="State"
                    isSearchable
                    options={STATES}
                    value={state}
                    name="state"
                    onChange={(e: any) => {
                      setState(e);
                      setAddressErrors([]);
                    }}
                  />
                </Grid>
                <Grid item xs={12} lg={6}>
                  <TextField
                    error={addressErrors.includes('Zipcode')}
                    required
                    label="Zipcode"
                    name={'Zipcode'}
                    value={zip}
                    onChange={(e) => {
                      setAddressErrors([]);
                      setZip(e.target.value);
                    }}
                    inputProps={{
                      minLength: 1,
                    }}
                    helperText={
                      addressErrors.includes('Zipcode')
                        ? zip.length && zip.length !== 5
                          ? 'Zip code should be of 5 digits'
                          : 'Please enter zip code'
                        : ''
                    }
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} paddingRight={{ lg: '180px' }}>
              <Disclosures
                state={address.state}
                carriers={purchasePolicyAdditionalData.carrier || 'MSI'}
                annualAmountPremium={options[1] && options[1].cost}
                monthlyDownPaymentAmount={options[0] && options[0].downPayment}
                monthlyInstallment={options[0] && options[0].cost}
                email={email}
                paymentType={paymentPlan}
                onChange={(value: boolean) => setAgreed(value)}
              ></Disclosures>
            </Grid>
            <Grid item xs={12} paddingRight={{ lg: '180px' }}>
              <Typography variant="caption">{getFraudLanguage()}</Typography>
            </Grid>
            <Grid
              item
              xs={12}
              paddingRight={{ lg: '180px' }}
              className={styles.paymentButton}
            >
              <Button
                id="buttonAddCCConfirm"
                data-submit-btn
                variant="contained"
                type="submit"
                startIcon={
                  loader ? <CircularProgress color="inherit" size="17px"/> : ''
                }
                disabled={!agreed || loader}
                onClick={onSubmit}
              >
                Pay Now
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Divider orientation="vertical" flexItem/>
        <Grid item lg={3} display={{ xs: 'none', md: 'block' }}>
          <Sidebar/>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PaymentMsiV1;
